import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  before: 'Piszesz nowy plan treningowy co tydzień od zera',
  after: 'Masz gotowy plan na pełne 40 tygodni — do użycia od zaraz'
}, {
  before: 'Nie wiesz co robić gdy pada deszcz lub masz małą grupę',
  after: 'Masz gotowe treści na każdy trening niezależnie od warunków'
}, {
  before: 'Rodzice pytają o wyniki ale nie masz nic do pokazania',
  after: 'Masz gotowe raporty dla rodziców na każdy miesiąc'
}, {
  before: 'Zawodnicy nie rozwijają się w sposób systematyczny',
  after: 'System oceny indywidualnej zawodnika na każdym poziomie'
}, {
  before: 'Improwizujesz na każdym treningu',
  after: 'Otwierasz PDF i trenujesz — zero stresu'
}];
export function BeforeAfter() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-navy-primary mb-8 md:mb-12" data-id="element-38">
          Zmiana którą poczujesz od pierwszego treningu
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-39">
          {/* Before Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 rounded-2xl p-5 md:p-8 border border-red-100 shadow-sm" data-id="element-40">
            <h3 className="text-xl md:text-2xl font-display font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-41">
              <X className="w-5 h-5 md:w-6 md:h-6" data-id="element-42" />
              PRZED systemem
            </h3>
            <div className="space-y-4" data-id="element-43">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-44">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-45" />
                  <p className="text-sm md:text-base text-gray-700" data-id="element-46">
                    {item.before}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* After Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50 rounded-2xl p-5 md:p-8 border border-green-100 shadow-sm" data-id="element-47">
            <h3 className="text-xl md:text-2xl font-display font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-48">
              <Check className="w-5 h-5 md:w-6 md:h-6" data-id="element-49" />
              PO systemie
            </h3>
            <div className="space-y-4" data-id="element-50">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-51">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-52" />
                  <p className="text-sm md:text-base text-gray-700" data-id="element-53">
                    {item.after}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}